import type { PlanningMember } from '@cockpit/shared';
import { ref, type Ref } from 'vue';
import { api } from '../api';

const cache: Ref<PlanningMember[] | null> = ref(null);
let pending: Promise<PlanningMember[]> | null = null;

/**
 * Membres de l'équipe (prénom, initiales, couleur), lus une fois via `GET /api/members` (tout membre
 * connecté) : choix « Pour » des tâches proposées par l'assistant, colonnes du Mode écran.
 */
export function useMembers(): {
  members: Ref<PlanningMember[] | null>;
  load: () => Promise<PlanningMember[]>;
} {
  async function load(): Promise<PlanningMember[]> {
    if (cache.value) return cache.value;
    pending ??= api
      .members()
      .then((list) => (cache.value = list))
      .catch(() => [])
      .finally(() => {
        pending = null;
      });
    return pending;
  }
  return { members: cache, load };
}
